import React, { Fragment, Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Preloader from "../components/atoms/preloader/Preloader";
import ScrollToTop from "../components/layout/ScrollToTop/ScrollToTop";
import { usePageTracking } from "../analytics/usePageTracking";
import ReactGA from "react-ga4";

const renderedRoutes = (routes) => {
  return routes.map((route, index) => {
    const Layout = route.layout || Fragment;
    return (
      <Route
        key={index}
        path={route.path}
        exact={route?.exact}
        element={
          <Layout>
            <Suspense fallback={<Preloader />}>
              <route.element />
            </Suspense>
          </Layout>
        }
      >
        {route.children && renderedRoutes(route.children)}
      </Route>
    );
  });
};

function AnalyticsWrapper() {
  usePageTracking();
  return null; // no UI, just tracking
}

const AppRouter = ({ routes }) => {

  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS);
  }, []);

  return (
    <>
      <ScrollToTop />
      <AnalyticsWrapper />
      <Routes>{renderedRoutes(routes)}</Routes>
    </>
  );
};

export default AppRouter;
